import { render, staticRenderFns } from "./新闻详情.vue?vue&type=template&id=63d623e2&scoped=true&"
import script from "./新闻详情.vue?vue&type=script&lang=js&"
export * from "./新闻详情.vue?vue&type=script&lang=js&"
import style0 from "./新闻详情.vue?vue&type=style&index=0&id=63d623e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d623e2",
  null
  
)

export default component.exports